import type React from 'react';
import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import type { BreadcrumbLinkClickPayload } from '@noths/polaris-design-system-candidate-components';

export const trackBreadcrumbClick = (
  e: React.MouseEvent<HTMLAnchorElement>,
  { linkDepth }: BreadcrumbLinkClickPayload,
) => {
  sendGALinkClickEvent(e, {
    event: 'custom_event',
    event_action: 'Link Click',
    event_category: 'Breadcrumb',
    event_label: `${linkDepth} Level(s) Up`,
    destination_URL: e.currentTarget.href,
  });
};
